<template>
	<mdb-breadcrumb>
		<mdb-breadcrumb-item v-for="(piece, index) in pieces" :key="index" :active="piece.active">
			<span v-if="piece.active">{{piece.label}}</span>
			<a v-else :href="piece.path">{{piece.label}}</a>
		</mdb-breadcrumb-item>
	</mdb-breadcrumb>
</template>

<script>
import { mdbBreadcrumb, mdbBreadcrumbItem } from '@/components/mdbvue'

export default {
	name: 'Breadcrumb',
	components: { mdbBreadcrumb, mdbBreadcrumbItem },
	computed: {
		pieces () {
			let path = '/'
			const pieces = [
				{
					active: this.$route.path === '/',
					path,
					label: 'home'
				}
			]
			this.$route.path.replace(/^\//, '').split('/').forEach(function (piece, index, pieces) {
				path += piece + '/'
				pieces.push({
					active: index === pieces.length - 1,
					path,
					label: piece
				})
			})
			return pieces
		}
	}
}
</script>

<style scoped>

</style>
